import { Vehicle } from './vehicles';
import { Employee } from './Employee';
import { Provider } from './provedor';
import api from './index';

export interface FuelingHistory {
  id: number;
  fueling_id: number | null;
  vehicle_id: number;
  employee_id: number;
  fuel_type: string;
  amount: number;
  cost_per_liter: number;
  total_cost: number;
  odometer_reading?: number;
  fueling_time: string;
  invoice_number?: string;
  notes?: string;
  created_at: string;
  updated_at: string;
  status: string;
  provider_id: number;
  action: string;
  details?: string;
  boleto_photo?: { url: string } | null;
  vehicle?: Vehicle;
  employee?: Employee;
  provider?: Provider;
}

const baseUrl = '/fuelings/history';
const deleteBaseUrl = '/history-fueling';

export const fuelingHistoryService = {
  async getAllFuelingHistory(): Promise<FuelingHistory[]> {
    const response = await api.get(baseUrl);
    return response.data;
  },
  async deleteHistory(id: number): Promise<void> {
    await api.delete(`${deleteBaseUrl}/${id}`);
  },
};
